import React from 'react';
import { Button } from 'reactstrap';
import {
  Pagination,
} from 'components/common/Tables';

const showButtons = (
  page,
  pages,
  setPage,
  filters, 
  setFilters,
  limit
) => (
  <div>
    {pages && pages.map(i => 
        <Button
          className= {page == i ? 'btn-success mr-1' : 'mr-1'}
          onClick={() => {
            window.scroll(0,0);
            setPage(i);
            setFilters({
              ...filters,
              offset: i <= 1 ? 0 :  (i - 1) * limit,
            });
          }}
        >
          {i}
        </Button>
    )}
  </div>
)



export const NextPrevButtons = ({page, setPage, pages, data, limit, filters, setFilters, offset}) => (
  <div className='d-flex justify-content-end'>
    {data.previous &&
      <Button 
        className="mr-2"
        onClick={() => {
          window.scroll(0,0);
          setPage(page - 1);
          setFilters({
            ...filters,
            offset: typeof(filters.offset) == 'undefined' ? 0 : filters.offset - limit,
          });
        }}
      >
        Prev
      </Button>
    }
    {data.next &&
      <Button 
        className="ml-2"
        onClick={() => {
          window.scroll(0,0);
          setPage(page + 1);
          setFilters({
            ...filters,
            offset: typeof(filters.offset) == 'undefined' ? limit : filters.offset + limit,
          });
        }}
      >
        Next
      </Button>
    }
  </div>
);

export default NextPrevButtons;



// WEBPACK FOOTER //
// ./src/components/common/NextPrevButtons.jsx